import { projectsApiClient } from "../common/axiosInstanceProjects";
import { handleAxiosError } from "../common/handleAxiosError";

export const getAllProjectSections = async (projectId: number) => {
  try {
    console.log('Fetching sections for project:', projectId);
    console.log('API URL:', `${projectsApiClient.defaults.baseURL}/sections/project/${projectId}`);
    
    // Configurar timeout específico para esta petición
    const response = await projectsApiClient.get(`/sections/project/${projectId}`, {
      timeout: 30000, // 30 segundos
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    });
    
    console.log('Sections API response:', response.data);
    return response.data;
  } catch (error: unknown) {
    console.error('Error fetching sections:', error);
    
    // Si es un error de timeout, devolver estructura vacía en lugar de fallar
    if ((error as Error & { code?: string }).code === 'ECONNABORTED' || (error as Error).message?.includes('timeout')) {
      console.warn('Sections API timeout, returning empty data structure');
      return {
        success: true,
        message: "No sections found (timeout)",
        data: []
      };
    }
    
    handleAxiosError(error, "Error al obtener las secciones");
  }
};